import { render } from "./PromoProducts.vue?vue&type=template&id=3afbaca8&scoped=true&ts=true"
import script from "./PromoProducts.vue?vue&type=script&lang=ts"
export * from "./PromoProducts.vue?vue&type=script&lang=ts"

import "./PromoProducts.vue?vue&type=style&index=0&id=3afbaca8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afbaca8"]])

export default __exports__